module.exports = __webpack_public_path__ + "static/img/logo-alipay.4613f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/invoice-manage/logo-alipay.png
// module id = 5Rav
// module chunks = 4